/**
 * 工具台账管理路由配置
 */
const toolRoute = {
  path: 'tool',
  name: 'tool',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'toolList',
      component: () => import('./index.vue'),
      meta: {
        navtabTitle: '工具台账管理',
        isCache: true,
        ignoreDiff: [],
        isIframe: false
      }
    }
  ]
};

export default toolRoute;
